import { Injectable } from '@angular/core';
import { ConsultaRESTBaseService } from './consulta-restbase.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Exercicios } from './exercicios.service';
import { AlertMessageService } from '@sigepe/sigepe-template';

export interface FiltroObterVinculosAgentesPublicos {
    codigoOrgao: number;
    codigoUpag: number;
    codigoUorg: number;
    cpf: number;
    nome: string;
    situacao: number;
}

export interface FiltroObterVinculoAgentePublico {
    codigoOrgao: number;
    matricula: number;
}

export interface FiltroObterVinculosAgentePublicoPaginacao extends FiltroObterVinculosAgentesPublicos {
    pageApi?: string;
    pageCurrent?: number;
    chaveServidor?: string;
}

export interface VinculoAgentePublico {
    cpf: string;
    nome: string;
    codigoOrgao?: number;
    descricaoOrgao: string;
    siglaOrgao?: string;
    codigoUpag?: number;
    codigoUorg?: number;
    matricula: number;
    situacaoVinculo: boolean;
    codigoGrupoCargo?: number;
    codigoCargo?: number;
    descricaoCargo: string;
    codigoSituacaoFuncional: number;
    descricaoSituacaoFuncional: string;
    regime: string;
    siglaRegime?: string;
    chaveServidor?: string;
    codigoOrgaoOrigem: number;
    descricaoOrgaoOrigem: string;
    siglaOrgaoOrigem?: string;
    codigoOrgaoExercicio: number;
    descricaoOrgaoExercicio: string;
    siglaOrgaoExercicio?: string;
    codigoTipoAquisicaoFerias: number;
    descricaoTipoAquisicaoFerias: string;
    nomeChefiaImediata: string;
    codigoUorgChefiaImediata: number;
    podeExecutarAcoes?: boolean;
    cargo?: string;
    contextoCessao?: boolean;
    orgaoExercicioExterno: boolean;
}

export interface ParametrosFeriasOrgao {
    pagamentoNoAdiantamento: boolean;
    quantidadeParcelasPagamento: number;
    percentualAdiantamento: number;
}

export interface ParametrosFeriasCargo {
    grupoCargo: string;
    quantidadeDiasFerias: number;
    permiteAbonoPecuniario: boolean;
}

export interface VinculoAgentePublicoComExercicios {
    dadosServidor: VinculoAgentePublico;
    exerciciosFerias: Exercicios[];
    parametrosFeriasOrgao: ParametrosFeriasOrgao;
    parametrosFeriasCargo: ParametrosFeriasCargo;
}

export interface ResultadoVinculosAgentesPublicos {
    servidores: VinculoAgentePublico[];
    paginacao: PaginacaoInfo;
    resultadoSiapeFoiLimitado: boolean;
}

export interface PaginacaoInfo {
    totalElements: number;
    pageCurrent: number;
    nextPage: string;
    previousPage: string;
}

@Injectable({
    providedIn: 'root'
})
export class VinculosService extends ConsultaRESTBaseService {
    constructor(alertaMsgService: AlertMessageService, http: HttpClient) {
        super(alertaMsgService, http);
    }

    public obterVinculosAgentesPublicos(filtro: FiltroObterVinculosAgentesPublicos): Observable<ResultadoVinculosAgentesPublicos> {
        const params = this.transformObjecttoParamArray(filtro);
        return super.get('/siape-selecionar-servidor/servidores', params, new HttpHeaders({ timeout: '120000' }));

        /*return of ({
            servidores: [
                {
                    cpf: "00000000000",
                    nome: "nome",
                    codigoOrgao: 1,
                    codigoUpag: 1,
                    codigoUorg: 1,
                    matricula: 1,
                    situacaoVinculo: true,
                    codigoGrupoCargo: 1,
                    codigoCargo: 1,
                    descricaoCargo: "descricaoCargo",
                    codigoSituacaoFuncional: 1,
                    descricaoSituacaoFuncional: "descricaoSituacaoFuncional",
                    regime: "CLT",
                    chaveServidor: "chaveServidor",
                    codigoOrgaoOrigem: 1,
                    descricaoOrgaoOrigem: "descricaoOrgaoOrigem",
                    codigoOrgaoExercicio: 1,
                    descricaoOrgaoExercicio: "descricaoOrgaoExercicio",
                    exercicios: [2025],
                    codigoTipoAquisicaoFerias: 1,
                    descricaoTipoAquisicaoFerias: "descricaoTipoAquisicaoFerias",
                    nomeChefiaImediata: "nomeChefiaImediata",
                    codigoUorgChefiaImediata: 1,
                    podeExecutarAcoes: true
                }
            ],
            paginacao: {
                totalElements: 1,
                pageCurrent: 1,
                nextPage: null,
                previousPage: null
            }
        });*/
    }

    public obterVinculoAgentePublico(filtro: FiltroObterVinculoAgentePublico): Observable<VinculoAgentePublicoComExercicios> {
        //return of(this.vinculo);

        const params = this.transformObjecttoParamArray(filtro);
        return super.get('/siape-selecionar-servidor/servidor', params);
    }

    public desfazerExercicioFerias(codigoOrgao, numeroMatricula, ano): Observable<any> {
        return super.delete(`/cenario/ferias-por-ano/${codigoOrgao}/${numeroMatricula}/${ano}`);
    }

    /*public badRequest(): Observable<any> {
        return super.post('/error-test/bad-request', null);
    }

    public unprocessableEntity(): Observable<any> {
        return super.post('/error-test/unprocessable-entity', null);
    }

    public internalServerError(): Observable<any> {
        return super.post('/error-test/internal-server-error', null);
    }*/

    /*private vinculo : any = {
        "dadosServidor": {
            "nome": "BRUNO BIANCO LEAL",
            "cpf": "220.123.808-16",
            "matricula": 2658010,
            "descricaoCargo": null,
            "codigoSituacaoFuncional": 18,
            "descricaoSituacaoFuncional": "EXERC DESCENT CARREI",
            "situacaoVinculo": false,
            "codigoOrgaoOrigem": 40106,
            "descricaoOrgaoOrigem": "AGU",
            "codigoOrgaoExercicio": 17000,
            "descricaoOrgaoExercicio": "MINISTERIO DA ECONOMIA",
            "codigoTipoAquisicaoFerias": null,
            "descricaoTipoAquisicaoFerias": null,
            "nomeChefiaImediata": null,
            "codigoUorgChefiaImediata": null
        },
        "exerciciosFerias": [
            {
                "idFerias": 66,
                "ano": 2016,
                "dataInicioPeriodoAquisitivo": "2015-06-15",
                "dataFimPeriodoAquisitivo": "2016-06-15",
                "quantidadeDias": 30,
                "situacao": "Não Solicitada",
                "parcelas": [
                    
                ]
            }
        ]
    };*/
}
